import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DeliveryRow from "./DeliveryRow";
import PendingDeliveryRow from "./PendingDeliveryRow";

const FONT = "'DM Sans', system-ui, sans-serif";

const HEAD_SX = {
  py: 2,
  px: 2,
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#4b5563",
  border: "none",
};

const TABLE_SX = {
  fontFamily: FONT,
  "& .MuiTableCell-root": { fontFamily: FONT },
  "& .MuiTableBody-root .MuiTableCell-root": { borderBottom: "none" },
  "& .MuiTableHead-root .MuiTableCell-root": {
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    backgroundColor: "#fff",
  },
};

const HEADINGS = [
  "ID",
  "Name",
  "Asset",
  "Status",
  "Moderation",
  "QC",
  "Action",
  "Created",
];

/** Ad Delivery table: delivery-pending requests and delivered hooks. */
const DeliveriesTable = ({
  deliveries,
  rejectedOnly,
  canCreateDelivery,
  onOpenDelivery,
  onOpenRequest,
  onDeliverRequest,
  onResubmit,
  retryS3,
}) => (
  <TableContainer sx={{ flex: "1 1 auto", minHeight: 0 }}>
    <Table size="medium" sx={TABLE_SX}>
      <TableHead>
        <TableRow
          sx={{ borderBottom: "1px solid #e5e7eb", backgroundColor: "#fff" }}
        >
          {HEADINGS.map((h) => (
            <TableCell
              key={h}
              sx={HEAD_SX}
              align={h === "Action" ? "right" : undefined}
            >
              {h}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {deliveries.length > 0 ? (
          deliveries.map((d) =>
            d.row_type === "delivery_pending" ? (
              <PendingDeliveryRow
                key={`pending-${d.ad_request_id}`}
                row={d}
                canCreateDelivery={canCreateDelivery}
                onOpenRequest={onOpenRequest}
                onDeliverRequest={onDeliverRequest}
              />
            ) : (
              <DeliveryRow
                key={d.id}
                row={d}
                canCreateDelivery={canCreateDelivery}
                onOpenDelivery={onOpenDelivery}
                onResubmit={onResubmit}
                retryS3={retryS3}
              />
            )
          )
        ) : (
          <TableRow>
            <TableCell
              colSpan={8}
              align="center"
              sx={{ py: 6, color: "text.secondary" }}
            >
              {rejectedOnly
                ? "No rejected deliveries in this range."
                : "No deliveries found."}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DeliveriesTable;
